import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const CheckInEmptyCircleIcon = ({
  width = "20",
  height = "24",
  color = "#27AE60",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 21 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.25 3C11.3991 3 12.5369 3.22633 13.5985 3.66605C14.6601 4.10578 15.6247 4.7503 16.4372 5.56282C17.2497 6.37533 17.8942 7.33992 18.3339 8.40152C18.7737 9.46312 19 10.6009 19 11.75C19 12.8991 18.7737 14.0369 18.3339 15.0985C17.8942 16.1601 17.2497 17.1247 16.4372 17.9372C15.6247 18.7497 14.6601 19.3942 13.5985 19.8339C12.5369 20.2737 11.3991 20.5 10.25 20.5C9.10093 20.5 7.96312 20.2737 6.90152 19.8339C5.83992 19.3942 4.87533 18.7497 4.06281 17.9372C3.2503 17.1247 2.60578 16.1601 2.16605 15.0985C1.72632 14.0369 1.5 12.8991 1.5 11.75C1.5 10.6009 1.72633 9.46311 2.16606 8.40152C2.60579 7.33992 3.25031 6.37532 4.06282 5.56281C4.87533 4.7503 5.83993 4.10578 6.90153 3.66605C7.96312 3.22632 9.10094 3 10.25 3L10.25 3Z"
          stroke={color}
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <path
          d="M13.875 9.8125L8.71875 14.9688L6.375 12.625"
          stroke={color}
          strokeWidth="1.875"
          strokeLinecap="square"
        />
      </svg>
    </IconWrapper>
  );
};
